import React from 'react';
import DataTable from 'components/data-table';
import { DetailTaiLieuRowItem } from 'modules/giai-quyet-don/datatable/rowItem'
import { header } from "constants/table";

class DanhSachBangChung extends React.Component {

  render() {
    return (
      <div>
        <div className="title">
          <div className="rows">
            <div className="col-12">
              <h3>DANH SÁCH TÀI LIỆU KÈM THEO</h3>
            </div>
          </div>
        </div>
        <div className="items-form white-table mb10">
          <div className="rows">
            <div className="col-12">
              <DataTable
                checkTraCuu={true}
                header={header.giaiQuyetDon.danhSachBangChung}
                dataList={this.props.parent}
                type="handle-letter-detail" hidePagination={true}
                hiddenButtonExport>
                <DetailTaiLieuRowItem />
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DanhSachBangChung.defaultProps = {
  listTaiLieuBangChung: []
}

export default DanhSachBangChung;


// WEBPACK FOOTER //
// ./src/components/modules/tra-cuu/DanhSachBangChung.jsx